<template>
<div class="chapter">
<div class="inner_page">
<div class="ack" id="ack">
<p class="chapterTitle1"><span class="bold">Acknowledgements</span></p>
<p class="paraNoIndent">Iris Ackroyd, Keith Atack, Vera Atack, Susan Barnes, Anna Blackburn, Joan Bostwick, Christine Boyce, Robert (Bob) Alan Dale, Kathleen Dale, Iris J Deller, Joanna C Murray Deller, Ricky S Deller, James Friend, John Goldfinch, Doris Hayes, Ann Howse, Doreen Howse, Kathleen Howse, Richard Huggett (1929–2000), Dr Hidayat Hussein, Tammy Jones, Brendan E McNally, John Marsh, Eleanor Nelder, Stanley Nelder, Dr Declan O’Reilly, Jackie Thomas, Julia Wiggett, Helen Vodden, Katie Vollens, Adam R Walker, Christine Walker, Darren J Walker, David Walker, Ivan P Walker, Paula L Walker, Suki B Walker, Dave Webster and Terry Webster of D Webster and son, Clifford Willoughby, Margaret Willoughby, Whittington Hospital social work team, the staff of the British Library, the staff of the British Library Newspaper Archive, Colindale, the staff of the Guildhall Library, the staff of the National Archive, Kew. I would particularly like to thank John D Murray who has assisted me over many years.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Fouldeeds_ack.vue?65a9b55a